// import Header from "../Modules/header/header";
import { Link } from "react-router-dom";
import logo from "src/Assets/images/LandingPageImages/skopic-image.png";
import settingsStyles from "src/Assets/css/settings/settings.module.css";

const LoginUserGuidelines = () => {
  function UserGuideLines() {
    return (
      <div className={settingsStyles.headerContainer}>
        <div className={settingsStyles.headerContainer}>
          <div>
            <img src={logo} alt="Skopic-Logo" width={90} height={48} />
          </div>
        </div>
        <div className="innercontainer">
          <h3 className={settingsStyles.privacyheading}>User Guidelines</h3>
          <div className={settingsStyles.TermsofService}>
          <p>
            <b>1. Welcome to Skopic</b>
          </p>
          <p>
            We welcome your questions, comments, concerns, and contributions.
            Skopic is designed to connect local communities through a shared
            knowledge network where members can exchange information, share
            thoughts, and ask questions about matters that are relevant to their
            communities.
          </p>
          <p>
            Our goal is to help communities stay informed, connected, and engaged
            through meaningful, timely, and useful information.
          </p>
          <br />

          <p>
            <b>2. Understand Our Terms of Use</b>
          </p>
          <p>
            Please review, understand, and comply with the Terms of Use available
            on the Skopic website and mobile applications.
          </p>
          <br />

          <p>
            <b>3. Contribute Meaningfully</b>
          </p>
          <p>
            Actively participate by sharing timely, relevant, and essential
            information that keeps your community informed and engaged.
          </p>
          <p>
            The more knowledge and insights you contribute, the stronger your
            community's knowledge base becomes. Skopic's Information Networking
            Engine helps members discover relevant information and find answers
            to their questions as the community's knowledge base grows over time.
          </p>
          <br />

          <p>
            <b>4. Keep Content Relevant to Your Community</b>
          </p>
          <p>
            Skopic communities are intended for sharing and discovering useful
            information about local communities and matters of common interest.
          </p>
          <p>
            Please avoid casual conversations, unrelated messages, and content
            that does not serve your community's purpose. Skopic is designed as a
            community information and knowledge-sharing platform, rather than a
            general-purpose social networking or chat platform.
          </p>
          <br />

          <p>
            <b>5. Avoid Continuous Conversations</b>
          </p>
          <p>
            Skopic limits posts to 280 characters and permits one attachment per
            post. Its user interface and information architecture are designed to
            encourage focused information sharing rather than extended,
            back-and-forth conversations.
          </p>
          <p>
            Please keep your contributions concise, informative, and relevant to
            the community.
          </p>
          <br />

          <p>
            <b>6. Use Community UPDATES and #TAGS Responsibly</b>
          </p>
          <p>
            When you publish a Community UPDATE or create a new #TAG, Skopic
            notifies members of your community.
          </p>
          <p>
            Please exercise discretion when creating TAGs or publishing UPDATES.
            Ensure that the content is relevant, timely, and useful before
            notifying your community members.
          </p>
          <br />

          <p>
            <b>7. Be Respectful</b>
          </p>
          <p>
            We are committed to maintaining a community environment that respects
            the dignity of every individual.
          </p>
          <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
            <li>Express your thoughts and perspectives respectfully.</li>
            <li>
              Avoid personal attacks or confrontational responses to other
              members' posts.
            </li>
            <li>
              Do not post content that is abusive, threatening, harassing, or
              intended to provoke arguments.
            </li>
            <li>
              Keep discussions constructive and focused on sharing information
              and perspectives.
            </li>
          </ul>
          <br />

          <p>
            <b>8. Protect Third-Party Rights</b>
          </p>
          <p>
            Do not post content that infringes upon the rights of any third
            party, including intellectual property, privacy, or publicity rights.
          </p>
          <br />

          <p>
            <b>9. Prohibited Content and Conduct</b>
          </p>
          <p>Do not:</p>
          <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
            <li>
              Publish inappropriate, unlawful, obscene, defamatory, threatening,
              or harassing content about individuals, groups, organizations, or
              beliefs.
            </li>
            <li>
              Repeatedly publish the same or substantially similar content
              (spam).
            </li>
            <li>
              Post content intended to provoke heated exchanges, debates, or
              arguments.
            </li>
            <li>Impersonate another person.</li>
            <li>
              Allow another person or entity to use your account or credentials
              to post or view content.
            </li>
          </ul>
          <br />

          <p>
            <b>10. Content Visibility and Enforcement</b>
          </p>
          <p>
            Please be aware that your posts are visible to all Skopic users,
            regardless of the communities to which they belong. Other users may
            therefore view or flag your posts if they are found inappropriate.
          </p>
          <p>
            Skopic reserves the right to remove posts that do not comply with
            these Community Guidelines.
          </p>
          <br />

          <p>
            <b>Thank You</b>
          </p>
          <p>
            Thank you for being part of Skopic and helping build a more informed,
            connected, and engaged community.
          </p>
          <p>
            Your contributions make your community's knowledge network stronger.
          </p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
      {/* <Header /> */}
      {<UserGuideLines />}
    </div>
  );
};
export default LoginUserGuidelines;
